import {signal, Signal} from '@angular/core';
import {TabStatus, TabStatusEnum} from './tab-status.model';

export function calculateTabClass(status: TabStatus): TabStatusEnum {
  if (status.completedSections === status.totalSections && status.totalSections > 0) {
    return TabStatusEnum.COMPLETED;
  }

  if (status.completedSections > 0) {
    return TabStatusEnum.IN_PROGRESS;
  }

  return TabStatusEnum.NOT_STARTED;
}

export function createTabStatusSignal(
  initialStatus: TabStatus = {totalSections: 0, completedSections: 0},
): {
  signal: Signal<TabStatus>;
  update: (status: TabStatus) => void;
} {
  const tabStatusSignal = signal(initialStatus);

  return {
    signal: tabStatusSignal.asReadonly(),
    update: (status: TabStatus) => tabStatusSignal.set(status),
  };
}

export function createTabManagementSignals(initialActiveTab = 0) {
  const activeTabIndex = signal(initialActiveTab);
  const loadedTabs = signal(new Set([initialActiveTab]));

  return {
    activeTabIndex,
    loadedTabs,
    onTabChange: (tabIndex: string | number) => {
      const index = typeof tabIndex === 'string' ? parseInt(tabIndex, 10) : tabIndex;
      activeTabIndex.set(index);
      loadedTabs.update((tabs) => new Set([...tabs, index]));
    },
  };
}
